import * as React from 'react';
import './userInfoConfirmation.module.scss';
import { observer } from 'mobx-react';
import { FieldSpec, UserFormState } from './states/UserFormState';

type ItemProp = {
    spec: FieldSpec;
    value: string | number;
};

export const UserInfoConfirmationItem = ({ spec, value }: ItemProp) => {
    const { label, type } = spec;

    let valueAsString = String(value);
    if (type === 'password') {
        valueAsString = '*'.repeat(valueAsString.length);
    }
    const displayValue = valueAsString;

    return (
        <div styleName="confirmation-item">
            <div styleName="label">{label}</div>
            <div styleName="value">{displayValue}</div>
        </div>
    );
};

type Props = {
    state: UserFormState;
};

@observer
export class UserInfoConfirmation extends React.Component<Props> {
    render() {
        const { state } = this.props;
        return (
            <div styleName="user-info-confirmation">
                {state.fieldSpecs.filter((spec) => spec.key !== 'password_confirmation').map((spec) => {
                    return <UserInfoConfirmationItem key={spec.key} spec={spec} value={state.getValue(spec.key)} />;
                })}
            </div>
        );
    }
}
